import React from 'react';
import './style.scss';
import { SomeWent_Wrong } from '../../../assets/images/index.js';
import ButtonComponent from '../ButtonComponent';
import { IoIosRefresh } from "react-icons/io";
import PropTypes from 'prop-types';

const CHUNK_ERROR_RETRY_KEY = 'chunk_error_retry_count';
const MAX_RETRIES = 2;
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, isChunkError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Error caught by ErrorBoundary:", error, info);

    const isChunkError =
      error?.name === "ChunkLoadError" ||
      error?.message?.includes("Loading chunk") ||
      error?.message?.includes("Failed to fetch dynamically imported module") ||
      error?.message?.includes("dynamically imported module") ||
      error?.message?.includes("Importing a module script failed");

    console.log("isChunkError:", isChunkError, "Error:", error);

    if (isChunkError) {
      const retryCount = parseInt(localStorage.getItem(CHUNK_ERROR_RETRY_KEY) || '0', 10);

      if (retryCount < MAX_RETRIES) {
        localStorage.setItem(CHUNK_ERROR_RETRY_KEY, retryCount + 1);
        this.setState({ isChunkError: true }, () => {
          setTimeout(() => {
            window.location.reload();
          }, 100);
        });
      } else {
        console.warn("Max chunk retry attempts reached. Showing fallback UI.");
        this.setState({ isChunkError: true });
      }
    }
  }

  componentDidMount() {
    if (!this.state.hasError) {
      localStorage.removeItem(CHUNK_ERROR_RETRY_KEY);
    }
  }

  render() {
    const { hasError, isChunkError } = this.state;

    if (!hasError) {
      return this.props.children;
    }

    if (isChunkError) {
      return (
        <div className="OppsText">
          <h2>Update Available</h2>
          <h4>
            A new version of this application is available. Please refresh to
            get the latest updates and fixes.
          </h4>
          <ButtonComponent
            text={
              <span className="RefreshIcon">
                <IoIosRefresh /> Refresh
              </span>
            }
            onClick={() => window.location.reload()}
          />
        </div>
      );
    }
    if (this.state.hasError) {
      return (
        <div>
          <div className="OppsText">
            <span className="SomeWent_Wrong">
              {" "}
              <img src={SomeWent_Wrong} />
            </span>
            <h4 className="">
              Oops..! Something went wrong.Please try again later.
            </h4>
            <div>
              <p className="mb-0 informationStyle">
                Sorry, we can&apos;t process your request at the moment.
              </p>
              <p className="informationText informationStyle">
                Please try again later
              </p>
              <div className=" informationText ">
                <ButtonComponent
                  className=" informationText informationStyle"
                  text={
                    <span className="RefreshIcon">
                      <IoIosRefresh /> {`Refresh`}
                    </span>
                  }
                  onClick={() => {
                    window.location.reload();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
